"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlateUtils = exports.Section = void 0;
const accumulateStateFromNodes_1 = require("./accumulateStateFromNodes");
const documentOutline_1 = require("./documentOutline");
const nodeMapper_1 = require("./nodeMapper");
const primaryLink_1 = require("./primaryLink");
const slateNodesToString_1 = require("./slateNodesToString");
var documentOutline_2 = require("./documentOutline");
Object.defineProperty(exports, "Section", { enumerable: true, get: function () { return documentOutline_2.Section; } });
class SlateUtils {
}
exports.SlateUtils = SlateUtils;
SlateUtils.accumulateStateFromNodes = accumulateStateFromNodes_1.accumulateStateFromNodes;
SlateUtils.nodesRecursiveForEach = accumulateStateFromNodes_1.nodesRecursiveForEach;
SlateUtils.hasUploadsInProgress = accumulateStateFromNodes_1.hasUploadsInProgress;
SlateUtils.primaryLink = primaryLink_1.primaryLink;
SlateUtils.nodeMapper = nodeMapper_1.nodeMapper;
SlateUtils.nodeMapperAsync = nodeMapper_1.nodeMapperAsync;
SlateUtils.documentOutline = documentOutline_1.documentOutline;
SlateUtils.sectionById = documentOutline_1.sectionById;
SlateUtils.nodesToSearchString = slateNodesToString_1.slateNodesToSearchString;
//# sourceMappingURL=index.js.map